import PropTypes from "prop-types";
import React from "react";
import StaticPage from "app/components/UI/StaticPage";
import classes from "./PendingPage.module.css";

export const PendingPage = ({ translate, translateHtml }) => (
  <StaticPage className={classes.pending__content}>
    <div className={classes.pending__title}>{translate("Ouverture prochaine")}</div>
    <div className={classes.pending__message}>
      {translateHtml("Chers golfeurs,<br />Votre site est en maintenance.<br />Merci de votre compréhension.")}
    </div>
  </StaticPage>
);

PendingPage.propTypes = {
  translate: PropTypes.func.isRequired,
  translateHtml: PropTypes.func.isRequired
};

export default PendingPage;



// WEBPACK FOOTER //
// ./src/app/components/PendingPage/PendingPage.js